export const environment = {
  production: true,
  // BASE_URL_IMPORT: 'http://localhost:8080',
  // BASE_URL_INITIAL_BALANCE: 'https://kastor-initial-balance-devel.herokuapp.com',
  // BASE_URL_REPORT: 'https://kastor-jsreport-production.herokuapp.com/api/report',
  // BASE_URL_REPORTS: 'https://kastor-report-production.herokuapp.com',
  // BASE_URL_CRUD: 'https://kastor-crud-production.herokuapp.com',
  // BASE_URL_ACCOUNTING_ACCOUNT: 'https://kastor-accounting-production.herokuapp.com',
  // BASE_URL_BULK_UPLOAD: 'https://kastor-bulk-production.herokuapp.com',
  // BASE_URL_COMMON_EXPENSES: 'https://kastor-common-expenses-production.herokuapp.com',
  // BASE_URL_MESSAGE: 'https://kastor-message-production.herokuapp.com',
  // BASE_URL_SSO: 'https://kastor-proxy-production.herokuapp.com/auth',
  // BASE_URL_KASTOR: 'https://app.kastorsoftware.cl',
  // BASE_URL_KIUNGO: 'https://app.kiungo.cl',
  // BASE_URL_TRANSLATION: 'https://kastor-translation-production.herokuapp.com',
  // BASE_URL_INTEGRATION: 'https://kastor-integration-production.herokuapp.com',
  SENTRY_DSN: 'https://11c13168a326440f85a6aab7ce8cb0f6@sentry.io/1479023',
  BASE_URL_REPORTS: 'https://kastor-reports-legacy.kastorsoftware.cl',
  BASE_URL_CRUD: 'https://kastor-crud-legacy.kastorsoftware.cl',
  BASE_URL_ACCOUNTING_ACCOUNT: 'https://kastor-accounting-legacy.kastorsoftware.cl',
  BASE_URL_BULK_UPLOAD: 'https://kastor-bulk-legacy.kastorsoftware.cl',
  BASE_URL_MESSAGE: 'https://kastor-message-legacy.kastorsoftware.cl',
  BASE_URL_SSO: 'https://kastor-proxy-legacy.kastorsoftware.cl/auth',
  BASE_URL_KASTOR: 'https://app.kastorsoftware.cl',
  BASE_URL_TRANSLATION: 'https://kastor-translation-legacy.kastorsoftware.cl',
  BASE_URL_INTEGRATION: 'https://kastor-integration-legacy.kastorsoftware.cl',
  REALM: 'kastor_genius'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts